import { CORSO_URL } from '~/utils/constants';
import { makeLoader, redirect } from '~/utils/routing';
import { storeParamSchema } from '~/utils/schemas';

export const { loader, useLoaderData: useOrderLookupData } = makeLoader(
  ({ params }, appState) => {
    const parsedParams = storeParamSchema.safeParse(params);
    const { settings } = appState.getState();

    if (!parsedParams.success || !settings) {
      return redirect('/');
    }

    const {
      isActive,
      storeUrl = CORSO_URL,
      registrations: {
        isEnabled: isRegistrationEnabled,
        isStartWarrantyClaimEnabled,
      },
      theme: {
        orderLookupDetailText,
        orderLookupRegistrationText,
        orderNumberDescriptionText,
      },
    } = settings;

    if (!isActive) {
      return redirect(`inactive?redirect=${encodeURI(storeUrl)}`);
    }

    const offerRegistration =
      isRegistrationEnabled && isStartWarrantyClaimEnabled;

    const orderLookupLabel =
      offerRegistration ? `Order or Registration Number` : `Order Number`;

    const startRegistrationText =
      offerRegistration ?
        (orderLookupRegistrationText ??
        `Didn't purchase from our online store?`)
      : undefined;

    return {
      orderNumberDescription: orderNumberDescriptionText,
      orderLookupDetailText,
      orderLookupLabel,
      startRegistrationText,
    };
  },
);
